<template>
  <div>
    <h1>Member Account Resources and Contacts</h1>
    <h2>Legal Contact</h2>
    <b-row>
      <b-col md="8" lg="6" xl="4">
        <p>
          This individual or group (email alias) will receive communications
          regarding any Bluetooth Legal Issues. This information will be
          visible to all users from your company.
        </p>
      </b-col>
    </b-row>
    <!-- forms -->
    <b-row>
      <!-- security contact form -->
      <b-col class="mt-3" md="8" lg="6" xl="4">
        <ContactForm title="Legal Contact" memberContactType="4" />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ContactForm from "@/components/ContactForm";
export default {
  name: "Legal",
  components: { ContactForm }
};
</script>
